import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Navbar from '../layout/Navbar';
import Select from 'react-select';
import {
  FETCH_DATA_FOR_UPDATE_DISPATCH_PLANNING,
  TRANSPORTER_LIST,
  SUB_TRANSPORTER_LIST,
  UPDATE_DISPATCH_TRANSPORT,
  UPDATE_DISPATCH_FUEL, VEHICLE_LIST_API, VEHICLE_DRIVER_LIST, UPDATE_DISPATCH_INFO, DELETE_DISPATCH_API 
} from '../../config/api';

function EditDispatch() {
  const [params] = useSearchParams();
  const dispatch_id = params.get('dispatch_id');
  const user_id = params.get('user_id');
  const org_id = params.get('org_id');

  const [form, setForm] = useState(null);
  const [editMode, setEditMode] = useState({ dispatch: false, transport: false, finance: false });
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [transporters, setTransporters] = useState([]);
  const [subTransporters, setSubTransporters] = useState([]);

  const [vehicles, setVehicles] = useState([]);
const [drivers, setDrivers] = useState([]);


useEffect(() => {
  fetchVehicles();
}, []);

const fetchVehicles = async () => {
  try {
    const res = await fetch(VEHICLE_LIST_API); // Add this to your `config/api.js`
    const data = await res.json();
    if (Array.isArray(data)) {
      setVehicles(data.map(v => ({ value: v.vehicle_no, label: v.vehicle_no })));
    }
  } catch (err) {
    console.error('Vehicle list fetch error', err);
  }
};

const handleVehicleChange = async (selected) => {
  setForm(prev => ({ ...prev, vehicle_no: selected?.value || '', driver_name: '', mobile: '' }));

  try {
    const res = await fetch(VEHICLE_DRIVER_LIST, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ vehicle_no: selected?.value || '' }),
    });

    const data = await res.json();
    if (Array.isArray(data)) {
      setDrivers(data.map(d => ({ value: d.driver_name, label: d.driver_name, mobile: d.mobile })));
    }
  } catch (err) {
    console.error('Driver list fetch error', err);
  }
};


const handleDriverChange = (selected) => {
  setForm(prev => ({
    ...prev,
    driver_name: selected?.value || '',
    mobile: selected?.mobile || '',
  }));
};
const [deleteAllowed, setDeleteAllowed] = useState(true);

  useEffect(() => {
    if (!dispatch_id || !user_id || !org_id) {
      setMessage('Missing parameters');
      setLoading(false);
      return;
    }

    fetch(FETCH_DATA_FOR_UPDATE_DISPATCH_PLANNING, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ dispatch_id, user_id, org_id })
    })
      .then(res => res.json())
      .then(data => {
        if (!form && data && data.dispatch_date) 
          {setForm(data); // prevent overwrite
        setDeleteAllowed(!data.is_invoiced);
          }
        else setMessage(data.error || 'No dispatch found');
      })
      .catch(() => setMessage('Server error'))
      .finally(() => setLoading(false));

    fetchTransporters();
  }, [dispatch_id, user_id, org_id]);

useEffect(() => {
  if (form?.transporter_id) fetchSubTransporters(form.transporter_id);
}, [form?.transporter_id]); 

  const fetchTransporters = async () => {
    try {
      const res = await fetch(TRANSPORTER_LIST);
      const data = await res.json();
      if (Array.isArray(data)) setTransporters(data);
    } catch (err) {
      console.error('Failed to fetch transporters', err);
    }
  };

  const fetchSubTransporters = async (transporter_id) => {
    try {
      const res = await fetch(SUB_TRANSPORTER_LIST, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ transporter_id })
      });
      const data = await res.json();
      if (Array.isArray(data)) setSubTransporters(data);
    } catch (err) {
      console.error('Failed to fetch sub-transporters', err);
    }
  };

const saveFuelInfo = async () => {
  try {
    const diesel_ltr = document.querySelector('[name="diesel_ltr"]')?.value || 0;
    const cash_amount = document.querySelector('[name="cash_amount"]')?.value || 0;
    const remark = document.querySelector('[name="remark"]')?.value || '';

    const payload = {
      dispatch_id: form.dispatch_id,
      diesel_ltr,
      cash_amount,
      remark,
      user_id,
    };

    const res = await fetch(UPDATE_DISPATCH_FUEL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    const result = await res.json();
    if (res.ok && result.success) {
      alert('Fuel and financial info updated');
      toggleEdit('finance');
      // update local state to reflect latest saved values
      setForm(prev => ({ ...prev, diesel_ltr, cash_amount, remark }));
    } else {
      alert(result.error || 'Update failed');
    }
  } catch (err) {
    console.error('Fuel update error:', err);
    alert('Server error during fuel update');
  }
};


const handleDeleteDispatch = async () => {
  if (!window.confirm('Are you sure you want to delete this dispatch?')) return;

  try {
    const res = await fetch(DELETE_DISPATCH_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ dispatch_id, user_id, org_id }),
    });

    const result = await res.json();
    if (res.ok && result.success) {
      alert('Dispatch deleted successfully');
      window.location.href = '/soplanning/search'; // or navigate somewhere else
    } else {
      alert(result.error || 'Failed to delete dispatch');
    }
  } catch (err) {
    console.error('Delete error:', err);
    alert('Server error while deleting');
  }
};


const saveDispatchInfo = async () => {
  try {
    const payload = {
      dispatch_id: form.dispatch_id,
      vehicle_no: form.vehicle_no,
      driver_name: form.driver_name,
      mobile: form.mobile,
      user_id,
      org_id
    };

    const res = await fetch(UPDATE_DISPATCH_INFO, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    const result = await res.json();
    if (res.ok && result.success) {
      alert('Dispatch info updated');
      toggleEdit('dispatch');
    } else {
      alert(result.error || 'Update failed');
    }
  } catch (err) {
    console.error('Dispatch update error:', err);
    alert('Server error during dispatch info update');
  }
};

  const saveTransportInfo = async () => {
    try {
      const payload = {
        dispatch_id: form.dispatch_id,
        transporter_id: form.transporter_id,
        sub_transporter_id: form.sub_transporter_id,
        user_id,
        org_id
      };

      const res = await fetch(UPDATE_DISPATCH_TRANSPORT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      const result = await res.json();
      if (res.ok && result.success) {
        alert('Transport info updated');
        toggleEdit('transport');
      } else {
        alert(result.error || 'Update failed');
      }
    } catch (err) {
      console.error('Transport update error:', err);
      alert('Server error during transport update');
    }
  };

  const toggleEdit = (section) => {
    setEditMode((prev) => ({ ...prev, [section]: !prev[section] }));
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const getLabel = (list, id) => {
    const item = list.find(i => i.id === parseInt(id));
    return item ? item.name : '-';
  };

  const InfoRow = ({ label, value }) => (
    <div className="row mb-2">
      <div className="col-md-4 fw-semibold">{label}:</div>
      <div className="col-md-8">{value || '-'}</div>
    </div>
  );

const EditRow = ({ label, name, value, defaultValue, type = 'text', onChange }) => (
  <div className="row mb-2">
    <div className="col-md-4 fw-semibold">{label}:</div>
    <div className="col-md-8">
      <input
        className="form-control"
        name={name}
        value={value}
        defaultValue={defaultValue}
        type={type}
        onChange={onChange}
      />
    </div>
  </div>
);


  // Warn user if closing tab with unsaved fuel data
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (editMode.finance) {
        e.preventDefault();
        e.returnValue = '';
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [editMode.finance]);

  return (
    <>
      <Navbar />
      <div className="container mt-4">
        <h4 className="mb-4">Dispatch Details</h4>
         <div>
   <button
  className="btn btn-sm btn-outline-danger me-2"
  onClick={handleDeleteDispatch}
  disabled={!deleteAllowed}
  title={!deleteAllowed ? 'Cannot delete: Invoice already generated' : ''}
>
  🗑️ Delete Dispatch
</button>

    
  </div>
        {loading ? (
          <p>Loading...</p>
        ) : !form ? (
          <p className="text-muted">{message || 'No dispatch data'}</p>
        ) : (
          <>
            {/* Card 1: Dispatch Info */}
            <div className="card shadow-sm p-4 mb-4">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="text-primary m-0">Dispatch Info</h5>
               {editMode.dispatch ? (
  <div>
    <button className="btn btn-sm btn-secondary me-2" onClick={() => toggleEdit('dispatch')}>Cancel</button>
    <button className="btn btn-sm btn-primary" onClick={saveDispatchInfo}>Save</button>
  </div>
) : (
  <button className="btn btn-sm btn-outline-primary" onClick={() => toggleEdit('dispatch')}>Edit</button>
)}
              </div>

              <InfoRow label="Created By" value={form.created_by} />
              <InfoRow label="Created On" value={form.created_on} />

              {editMode.dispatch ? (
                <>
                  <div className="row mb-2">
  <div className="col-md-4 fw-semibold">Vehicle No:</div>
  <div className="col-md-8">
    <Select
      options={vehicles}
      value={vehicles.find(v => v.value === form.vehicle_no)}
      onChange={handleVehicleChange}
      isClearable
    />
  </div>
</div>

<div className="row mb-2">
  <div className="col-md-4 fw-semibold">Driver Name:</div>
  <div className="col-md-8">
    <Select
      options={drivers}
      value={drivers.find(d => d.value === form.driver_name)}
      onChange={handleDriverChange}
      isClearable
    />
  </div>
</div>

<EditRow
  label="Driver Mobile"
  name="mobile"
  value={form.mobile}
  type="text"
    onChange={handleEditChange}
/>
                </>
              ) : (
                <>
                  <InfoRow label="Dispatch ID" value={form.dispatch_id} />
                  <InfoRow label="Planning ID" value={form.planning_id} />
                  <InfoRow label="Dispatch Date" value={form.dispatch_date} />
                  <InfoRow label="Vehicle No" value={form.vehicle_no} />
                  <InfoRow label="Driver Name" value={form.driver_name} />
                  <InfoRow label="Driver Mobile" value={form.driver_mobile} />
                </>
              )}
            </div>

            {/* Card 2: Transport Info */}
            <div className="card shadow-sm p-4 mb-4">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="text-success m-0">Transport Info</h5>
                {editMode.transport ? (
                  <div>
                    <button className="btn btn-sm btn-secondary me-2" onClick={() => toggleEdit('transport')}>Cancel</button>
                    <button className="btn btn-sm btn-success" onClick={saveTransportInfo}>Save</button>
                  </div>
                ) : (
                  <button className="btn btn-sm btn-outline-success" onClick={() => toggleEdit('transport')}>Edit</button>
                )}
              </div>

              {editMode.transport ? (
                <>
                  <div className="row mb-2">
                    <div className="col-md-4 fw-semibold">Transporter:</div>
                    <div className="col-md-8">
                      <Select
                        options={transporters.map(t => ({ value: t.id, label: t.name }))}
                        value={transporters.find(t => t.id === parseInt(form.transporter_id))}
                        onChange={(selected) => {
                          setForm(prev => ({ ...prev, transporter_id: selected.value, sub_transporter_id: '' }));
                          fetchSubTransporters(selected.value);
                        }}
                      />
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-4 fw-semibold">Sub Transporter:</div>
                    <div className="col-md-8">
                      <Select
                        options={subTransporters.map(st => ({ value: st.id, label: st.name }))}
                        value={
                          subTransporters
                            .map(st => ({ value: st.id, label: st.name }))
                            .find(st => st.value === parseInt(form.sub_transporter_id))
                        }
                        onChange={(selected) => setForm(prev => ({ ...prev, sub_transporter_id: selected.value }))}
                      />
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <InfoRow label="Transporter" value={form.transporter_name || getLabel(transporters, form.transporter_id)} />
                  <InfoRow label="Sub Transporter" value={form.sub_transporter_name || getLabel(subTransporters, form.sub_transporter_id)} />
                </>
              )}
            </div>

            {/* Card 3: Fuel & Financial Info */}
            <div className="card shadow-sm p-4 mb-4 border-start border-3 border-warning">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="text-warning m-0">Fuel & Financial Info</h5>
                {editMode.finance ? (
                  <div>
                    <button className="btn btn-sm btn-secondary me-2" onClick={() => toggleEdit('finance')}>Cancel</button>
                    <button className="btn btn-sm btn-warning" onClick={saveFuelInfo}>Save</button>
                  </div>
                ) : (
                  <button className="btn btn-sm btn-outline-warning" onClick={() => toggleEdit('finance')}>Edit</button>
                )}
              </div>

              {editMode.finance ? (
                <>
                <EditRow label="Diesel Issued (Ltr)" name="diesel_ltr" defaultValue={form.diesel_ltr} type="number" />
<EditRow label="Cash Amount (₹)" name="cash_amount" defaultValue={form.cash_amount} type="number" />
<EditRow label="Remark" name="remark" defaultValue={form.remark} />

                </>
              ) : (
                <>
                  <InfoRow label="Diesel Issued (Ltr)" value={form.diesel_ltr} />
                  <InfoRow label="Cash Amount (₹)" value={form.cash_amount} />
                  <InfoRow label="Remark" value={form.remark} />
                </>
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default EditDispatch;
